import React from 'react';

import Events from '@/pages/Common/Events';
import ViewEvent from '@/pages/Common/Events/ViewEvent';
import Glossary from '@/pages/Common/Glossary';
import Watch from '@/pages/Common/Glossary/Watch';
import Notifications from '@/pages/Common/Notifications';
import DashboardLayout from '@components/templates/layouts/Outlet/DashboardLayout';
const Painel = React.lazy(() => import('pages/Admin/Painel'));
const EnterpriseDetails = React.lazy(() => import('pages/Common/EnterpriseDetails'));
const Error404 = React.lazy(() => import('pages/Errors/404'));

const AdminConsultoriaRoutes = {
    path: '/admin_consultoria',
    element: <DashboardLayout />,
    children: [
        {
            path: '/admin_consultoria/painel/:mainTab?/:tab?/:id?',
            element: <Painel />
        },
        {
            path: '/admin_consultoria/empresa/:tabValue?/:id?/:tab?/:modelId?',
            element: <EnterpriseDetails />
        },
        {
            path: '/admin_consultoria/glossario',
            element: <Glossary />
        },
        {
            path: '/admin_consultoria/glossario/assistir/:id',
            element: <Watch />
        },
        {
            path: '*',
            element: <Error404 />
        },
        {
            path: '/admin_consultoria/encontros-ao-vivo',
            element: <Events />
        },
        {
            path: '/admin_consultoria/encontros-ao-vivo/:id',
            element: <ViewEvent />
        },
        {
            path: '/admin_consultoria/notificacoes',
            element: <Notifications />
        }
    ]
};
export default AdminConsultoriaRoutes;
